import styled from "styled-components";

const Link = styled.a`
  position: absolute;
  top: -40px;
  left: 24px;
  background: ${({ theme }) => theme.accent};
  color: ${({ theme }) => theme.accentContrast};
  padding: 10px 16px;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-weight: 600;
  transition: top 0.2s ease;
  z-index: 1000;

  &:focus {
    top: 16px;
  }
`;

function SkipLink() {
  return <Link href="#main-content">Skip to content</Link>;
}

export default SkipLink;
